/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Dialog_Reject_PlaceholderInputs */

const vi_sl_detail_dialog_reject_placeholder = /** @type {(inputs: Sl_Detail_Dialog_Reject_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: Sai khối lượng`)
};

/**

* @param {Sl_Detail_Dialog_Reject_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_dialog_reject_placeholder = /** @type {((inputs?: Sl_Detail_Dialog_Reject_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Dialog_Reject_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_dialog_reject_placeholder(inputs)
});